
import Vue from 'vue'
import {NewSensorsApiFunc, setAccessToken} from '@/api'
import { Sensor } from '@/models'

import SensorList from './components/SensorList.vue'
import TheTemplate from '../TheTemplate.vue'
import SearchForm from '@/components/BaseSearchForm.vue'
import Pager from '@/components/BasePager.vue'

export type FilterCondition = {
  type?: string;
  battery?: string;
  status?: string;
  word?: string;
}

const SIX_SECONDS = 6000

export type DataType = {
  sensors: Array<Sensor>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
  defaultIntervalId: number | undefined;
  currentPageIntervalId: number | undefined;
}

export default Vue.extend({
  name: 'SensorListScreen',

  data(): DataType {
    return {
      sensors: [],
      filterCondition: {
        type: '',
        battery: '',
        status: '',
        word: '',
      },
      totalPage: 0,
      currentPage: 0,
      defaultIntervalId: undefined,
      currentPageIntervalId: undefined
    }
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin"
    }
  },

  async mounted() {
    this.fetchSensors()
    this.defaultIntervalId = window.setInterval(() => this.fetchSensors(), SIX_SECONDS)
  },

  destroyed() {
    window.clearInterval(this.defaultIntervalId)
    this.defaultIntervalId = undefined
    window.clearInterval(this.currentPageIntervalId)
    this.currentPageIntervalId = undefined
  },

  watch: {
    $route(to, from) {
      if (to.params.updated === 'true') {
        this.fetchSensors(this.currentPage)
      }
    }
  },

  components: {
    TheTemplate,
    SearchForm,
    SensorList,
    Pager
  },

  methods: {
    async fetchSensors(page?: number): Promise<void> {
      const companyId = this.$auth.companyId
      if (!companyId) {
        this.$router.replace({name: 'login'})
        return
      }
      const filterString: string = JSON.stringify({
        q: this.filterCondition.word,
        type: this.filterCondition.type,
        battery: this.filterCondition.battery,
        status: this.filterCondition.status
      })
        setAccessToken(this.$auth.accessToken)
        const { data, err } = await NewSensorsApiFunc().listSensors(companyId, filterString, page)

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchSensors(page)
        })
        return
      }

      this.sensors = data.list
      this.currentPage = data.currentPage
      this.totalPage = data.totalPage
    },

    updateFilterCondition(condition?: FilterCondition): void {
      this.filterCondition = Object.assign(this.filterCondition, condition)
    },

    changePage(page: number): void {
      window.clearInterval(this.defaultIntervalId)
      this.defaultIntervalId = undefined;
      window.clearInterval(this.currentPageIntervalId)
      this.currentPageIntervalId = undefined;
      this.fetchSensors(page)
      this.currentPageIntervalId = window.setInterval(() => this.fetchSensors(page), SIX_SECONDS);
    }
  }
})
